import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 0,
    class: "mb-4 font-bold text-secondary"
};
const _hoisted_3 = { class: "text-center fw-light mb-4" };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "text-center text-secondary mb-1" };
const _hoisted_6 = { class: "text-center text-secondary mb-1" };
const _hoisted_7 = { class: "form-floating mb-3" };
const _hoisted_8 = ["placeholder"];
const _hoisted_9 = { for: "email" };
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = ["placeholder"];
const _hoisted_12 = { for: "password" };
const _hoisted_13 = { class: "form-check mb-1" };
const _hoisted_14 = ["checked"];
const _hoisted_15 = {
    class: "form-check-label",
    for: "remember"
};
const _hoisted_16 = ["disabled"];
const _hoisted_17 = { key: 1 };
const _hoisted_18 = {
    key: 0,
    class: "mb-4 font-bold text-secondary"
};
const _hoisted_19 = { class: "text-center fw-light mb-4" };
const _hoisted_20 = { class: "form-floating mb-3" };
const _hoisted_21 = ["placeholder"];
const _hoisted_22 = { for: "email" };
const _hoisted_23 = { class: "w-100 btn btn-primary d-flex align-items-center justify-content-center text-white" };
const _hoisted_24 = { key: 2 };
const _hoisted_25 = {
    key: 0,
    class: "mb-4 font-bold text-secondary"
};
const _hoisted_26 = { class: "text-center fw-light mb-4" };
const _hoisted_27 = { class: "form-floating mb-3" };
const _hoisted_28 = ["placeholder"];
const _hoisted_29 = { for: "email" };
const _hoisted_30 = { class: "form-floating mb-3" };
const _hoisted_31 = ["placeholder"];
const _hoisted_32 = { for: "token" };
const _hoisted_33 = { class: "form-floating mb-3" };
const _hoisted_34 = ["placeholder"];
const _hoisted_35 = { for: "password" };
const _hoisted_36 = { class: "form-floating mb-3" };
const _hoisted_37 = ["placeholder"];
const _hoisted_38 = { for: "passwordConfirmation" };
const _hoisted_39 = {
    key: 1,
    class: "fw-bold text-danger mb-3"
};
const _hoisted_40 = ["disabled"];
const _hoisted_41 = { key: 3 };
const _hoisted_42 = {
    key: 0,
    class: "mb-4 font-bold text-secondary"
};
const _hoisted_43 = { class: "text-center fw-light mb-4" };
const _hoisted_44 = { class: "row" };
const _hoisted_45 = { class: "col-12 col-lg-6" };
const _hoisted_46 = { class: "mb-3" };
const _hoisted_47 = { class: "form-floating mb-3" };
const _hoisted_48 = ["placeholder"];
const _hoisted_49 = { for: "company" };
const _hoisted_50 = { class: "form-floating mb-3" };
const _hoisted_51 = ["placeholder"];
const _hoisted_52 = { for: "title" };
const _hoisted_53 = { class: "form-floating mb-3" };
const _hoisted_54 = ["placeholder"];
const _hoisted_55 = { for: "firstname" };
const _hoisted_56 = { class: "form-floating mb-3" };
const _hoisted_57 = ["placeholder"];
const _hoisted_58 = { for: "lastname" };
const _hoisted_59 = { class: "form-floating mb-3" };
const _hoisted_60 = ["placeholder"];
const _hoisted_61 = { for: "email" };
const _hoisted_62 = { class: "form-floating mb-3" };
const _hoisted_63 = ["placeholder"];
const _hoisted_64 = { for: "phone" };
const _hoisted_65 = { class: "form-floating mb-3" };
const _hoisted_66 = ["value"];
const _hoisted_67 = { for: "language" };
const _hoisted_68 = { class: "form-check mb-3" };
const _hoisted_69 = ["checked"];
const _hoisted_70 = {
    class: "form-check-label",
    for: "newsletterAbo"
};
const _hoisted_71 = { class: "col-12 col-lg-6" };
const _hoisted_72 = { class: "mb-3" };
const _hoisted_73 = { class: "form-floating mb-3" };
const _hoisted_74 = ["placeholder"];
const _hoisted_75 = { for: "addressCompany" };
const _hoisted_76 = { class: "form-floating mb-3" };
const _hoisted_77 = ["placeholder"];
const _hoisted_78 = { for: "addressFirstname" };
const _hoisted_79 = { class: "form-floating mb-3" };
const _hoisted_80 = ["placeholder"];
const _hoisted_81 = { for: "addressLastname" };
const _hoisted_82 = { class: "form-floating mb-3" };
const _hoisted_83 = ["placeholder"];
const _hoisted_84 = { for: "address" };
const _hoisted_85 = { class: "form-floating mb-3" };
const _hoisted_86 = ["placeholder"];
const _hoisted_87 = { for: "zipcode" };
const _hoisted_88 = { class: "form-floating mb-3" };
const _hoisted_89 = ["placeholder"];
const _hoisted_90 = { for: "city" };
const _hoisted_91 = { class: "form-floating mb-3" };
const _hoisted_92 = ["value"];
const _hoisted_93 = { for: "country" };
const _hoisted_94 = { class: "form-floating mb-3" };
const _hoisted_95 = ["placeholder"];
const _hoisted_96 = { for: "password" };
const _hoisted_97 = { class: "form-floating mb-3" };
const _hoisted_98 = ["placeholder"];
const _hoisted_99 = { for: "passwordConfirmation" };
const _hoisted_100 = {
    key: 1,
    class: "fw-bold text-danger mb-3"
};
const _hoisted_101 = { class: "form-check mb-3" };
const _hoisted_102 = ["innerHTML"];
const _hoisted_103 = ["disabled"];
import { responseMessages } from '@/Composables/responseMessages';
import { useTrans } from '@/Composables/useTrans';
import { loadTenantConfigs } from '@/Configurator/Composables/standardFunctions';
import { useForm } from '@inertiajs/vue3';
import axios from 'axios';
import { debounce } from 'lodash';
import { onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerLoginAndRegistrationForm',
    props: {
        tenantId: String,
        countries: {
            type: Array,
            default: () => []
        },
        languages: {
            type: Array,
            default: []
        },
        status: {
            type: String,
            default: null,
        },
        allowRegistration: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['loggedIn'],
    setup(__props, { emit: __emit }) {
        let { showErrorSwal, showSuccessSwal } = responseMessages();
        const { t } = useI18n();
        const { trans } = useTrans();
        const props = __props;
        const emit = __emit;
        const privacyUrl = ref('');
        const tocUrl = ref('');
        const loginForm = useForm({
            email: '',
            password: '',
            remember: false,
            tenant_uuid: props.tenantId
        });
        const registerForm = useForm({
            company: '',
            title: '',
            firstname: '',
            lastname: '',
            email: '',
            phone: '',
            addressCompany: '',
            addressFirstname: '',
            addressLastname: '',
            address: '',
            zipcode: '',
            city: '',
            countryId: '',
            lang: 'de',
            newsletterAbo: false,
            password: '',
            passwordConfirmation: ''
        });
        const resetForm = useForm({
            email: '',
            token: '',
            password: '',
            passwordConfirmation: ''
        });
        const emailExists = ref(false);
        const currentStep = ref('login');
        const debouncedEmailCheck = debounce(() => {
            if (registerForm.email) {
                axios.post(route('customer.registration.check', props.tenantId), {
                    email: registerForm.email
                })
                    .then(function (response) {
                    if (response.data != null && response.data != '') {
                        emailExists.value = response.data.exists;
                        if (emailExists.value) {
                            showErrorSwal(t('Diese E-Mail-Adresse ist bereits registriert. Bitte verwenden Sie eine andere E-Mail-Adresse.'));
                        }
                    }
                    else {
                        emailExists.value = false;
                    }
                })
                    .catch(function (error) {
                    console.log(error);
                    emailExists.value = false;
                });
            }
        }, 1000);
        onMounted(async () => {
            privacyUrl.value = await loadTenantConfigs('privacy_url');
            tocUrl.value = await loadTenantConfigs('toc_url');
        });
        watch(() => registerForm.email, (newValue) => {
            debouncedEmailCheck();
        });
        watch(() => registerForm.company, (newValue) => {
            registerForm.addressCompany = newValue;
        });
        watch(() => registerForm.firstname, (newValue) => {
            registerForm.addressFirstname = newValue;
        });
        watch(() => registerForm.lastname, (newValue) => {
            registerForm.addressLastname = newValue;
        });
        function login() {
            loginForm.post(route('customer.login'), {
                onFinish: () => {
                    loginForm.reset('password');
                    emit('loggedIn');
                },
                onError: (errors) => {
                    showErrorSwal(t('Zugangsdaten fehlerhaft'));
                },
            });
        }
        function forgotPasswordSubmit() {
            axios.post(route('password.email', props.tenantId), {
                email: resetForm.email
            })
                .then(function (response) {
                showSuccessSwal(t('Wenn ein Account mit dieser E-Mail-Adresse existiert, erhalten Sie in Kürze eine E-Mail mit einem Code zum Zurücksetzen Ihres Passworts.'));
                currentStep.value = 'resetPassword';
            })
                .catch(function (error) {
                console.log(error);
                currentStep.value = 'requestPassword';
                showErrorSwal(t('Beim Senden der E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'));
            });
        }
        function resetPasswordSubmit() {
            axios.post(route('password.reset', props.tenantId), {
                email: resetForm.email,
                token: resetForm.token,
                password: resetForm.password,
                password_confirmation: resetForm.passwordConfirmation
            })
                .then(function (response) {
                if (response.status == 200) {
                    resetForm.reset();
                    showSuccessSwal(response.data.message);
                    currentStep.value = 'login';
                }
                else {
                    showErrorSwal(response.data.message);
                }
            })
                .catch(function (error) {
                console.log(error);
                currentStep.value = 'resetPassword';
                showErrorSwal(t('Fehler beim Zurücksetzen des Passworts. Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.'));
            });
        }
        function register() {
            registerForm.transform((data) => ({
                company: data.company,
                title: data.title,
                firstname: data.firstname,
                lastname: data.lastname,
                email: data.email,
                phone: data.phone,
                address_company: data.addressCompany,
                address_firstname: data.addressFirstname,
                address_lastname: data.addressLastname,
                address: data.address,
                zipcode: data.zipcode,
                city: data.city,
                country_id: data.countryId,
                lang: data.lang,
                newsletter_abo: data.newsletterAbo,
                password: data.password,
                password_confirmation: data.passwordConfirmation
            })).post(route('customer.registration.store', props.tenantId), {
                onFinish: () => {
                    registerForm.reset();
                    emit('loggedIn');
                },
                onError: (errors) => {
                    showErrorSwal(t('Fehler bei der Registrierung. Bitte erneut versuchen.'));
                },
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (currentStep.value === 'login')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("form", {
                            onSubmit: _withModifiers(login, ["prevent"])
                        }, [
                            (props.status)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.status), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(t)('Anmeldung')), 1),
                            (props.allowRegistration)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('Noch kein Account?')), 1),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "w-100 btn btn-outline-primary mb-3",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (currentStep.value = 'register'))
                                    }, _toDisplayString(_unref(t)('Neuen Account erstellen')), 1),
                                    _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('Jetzt einloggen')), 1)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_7, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "email",
                                    class: "form-control",
                                    id: "email",
                                    placeholder: _unref(t)('E-Mail'),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(loginForm).email) = $event))
                                }, null, 8, _hoisted_8), [
                                    [_vModelText, _unref(loginForm).email]
                                ]),
                                _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('E-Mail')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "password",
                                    class: "form-control",
                                    id: "password",
                                    placeholder: _unref(t)('Passwort'),
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(loginForm).password) = $event))
                                }, null, 8, _hoisted_11), [
                                    [_vModelText, _unref(loginForm).password]
                                ]),
                                _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(t)('Passwort')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: "remember",
                                    checked: _unref(loginForm).remember
                                }, null, 8, _hoisted_14),
                                _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(t)('Angemeldet bleiben?')), 1)
                            ]),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-link w-100 mb-3",
                                onClick: _cache[3] || (_cache[3] = ($event) => (currentStep.value = 'requestPassword'))
                            }, _toDisplayString(_unref(t)('Passwort vergessen?')), 1),
                            _createElementVNode("button", {
                                class: "w-100 btn btn-primary d-flex align-items-center justify-content-center text-white",
                                disabled: _unref(loginForm).processing
                            }, [
                                _createTextVNode(_toDisplayString(_unref(t)('Login')), 1),
                                _cache[28] || (_cache[28] = _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "ms-2 bi bi-arrow-right",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                    })
                                ], -1))
                            ], 8, _hoisted_16)
                        ], 32)
                    ]))
                    : _createCommentVNode("", true),
                (currentStep.value === 'requestPassword')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("form", {
                            onSubmit: _withModifiers(forgotPasswordSubmit, ["prevent"])
                        }, [
                            (props.status)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(props.status), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("h4", _hoisted_19, _toDisplayString(_unref(t)('Passwort vergessen?')), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "w-100 btn btn-outline-primary mb-3",
                                onClick: _cache[4] || (_cache[4] = ($event) => (currentStep.value = 'login'))
                            }, _toDisplayString(_unref(t)('Jetzt einloggen')), 1),
                            _createElementVNode("p", null, _toDisplayString(_unref(t)('Bitte die Email-Adresse zum gewünschten Konto eingeben.')), 1),
                            _createElementVNode("div", _hoisted_20, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "email",
                                    class: "form-control",
                                    id: "email",
                                    placeholder: _unref(t)('E-Mail'),
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(resetForm).email) = $event))
                                }, null, 8, _hoisted_21), [
                                    [_vModelText, _unref(resetForm).email]
                                ]),
                                _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)('E-Mail')), 1)
                            ]),
                            _createElementVNode("button", _hoisted_23, [
                                _createTextVNode(_toDisplayString(_unref(t)('Passwort zurücksetzen')), 1),
                                _cache[29] || (_cache[29] = _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "ms-2 bi bi-arrow-right",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                    })
                                ], -1))
                            ])
                        ], 32)
                    ]))
                    : _createCommentVNode("", true),
                (currentStep.value === 'resetPassword')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("form", {
                            onSubmit: _withModifiers(resetPasswordSubmit, ["prevent"])
                        }, [
                            (props.status)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(props.status), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("h4", _hoisted_26, _toDisplayString(_unref(t)('Passwort zurücksetzen')), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "w-100 btn btn-outline-primary mb-3",
                                onClick: _cache[6] || (_cache[6] = ($event) => (currentStep.value = 'login'))
                            }, _toDisplayString(_unref(t)('Jetzt einloggen')), 1),
                            _createElementVNode("p", null, _toDisplayString(_unref(t)('Bitte die Email-Adresse zum gewünschten Konto, den zugesendeten Rücksetzungs-Code und das neue Passwort eingeben.')), 1),
                            _createElementVNode("div", _hoisted_27, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "email",
                                    class: "form-control",
                                    id: "email",
                                    placeholder: _unref(t)('E-Mail'),
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(resetForm).email) = $event))
                                }, null, 8, _hoisted_28), [
                                    [_vModelText, _unref(resetForm).email]
                                ]),
                                _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(t)('E-Mail')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "token",
                                    placeholder: _unref(t)('Rücksetzungs-Code'),
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(resetForm).token) = $event)),
                                    required: ""
                                }, null, 8, _hoisted_31), [
                                    [_vModelText, _unref(resetForm).token]
                                ]),
                                _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(t)('Rücksetzungs-Code')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "password",
                                    class: "form-control",
                                    id: "password",
                                    placeholder: _unref(t)('Passwort'),
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(resetForm).password) = $event)),
                                    required: ""
                                }, null, 8, _hoisted_34), [
                                    [_vModelText, _unref(resetForm).password]
                                ]),
                                _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(t)('Passwort')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "password",
                                    class: "form-control",
                                    id: "passwordConfirmation",
                                    placeholder: _unref(t)('Passwort bestätigen'),
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(resetForm).passwordConfirmation) = $event)),
                                    required: ""
                                }, null, 8, _hoisted_37), [
                                    [_vModelText, _unref(resetForm).passwordConfirmation]
                                ]),
                                _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(t)('Passwort bestätigen')), 1)
                            ]),
                            (_unref(resetForm).password !== _unref(resetForm).passwordConfirmation)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(t)('Passwörter stimmen nicht überein')), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("button", {
                                class: "w-100 btn btn-primary d-flex align-items-center justify-content-center text-white",
                                disabled: _unref(resetForm).processing || _unref(resetForm).password !== _unref(resetForm).passwordConfirmation
                            }, [
                                _createTextVNode(_toDisplayString(_unref(t)('Passwort zurücksetzen')), 1),
                                _cache[30] || (_cache[30] = _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "ms-2 bi bi-arrow-right",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                    })
                                ], -1))
                            ], 8, _hoisted_40)
                        ], 32)
                    ]))
                    : _createCommentVNode("", true),
                (currentStep.value === 'register')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("form", {
                            onSubmit: _withModifiers(register, ["prevent"])
                        }, [
                            (props.status)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(props.status), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("h4", _hoisted_43, _toDisplayString(_unref(t)('Registrierung')), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "w-100 btn btn-outline-primary mb-3",
                                onClick: _cache[11] || (_cache[11] = ($event) => (currentStep.value = 'login'))
                            }, _toDisplayString(_unref(t)('Ich habe bereits einen Account')), 1),
                            _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("h4", _hoisted_46, _toDisplayString(_unref(t)('Details')), 1),
                                    _createElementVNode("div", _hoisted_47, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "company",
                                            placeholder: _unref(t)('Firma'),
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(registerForm).company) = $event)),
                                            required: ""
                                        }, null, 8, _hoisted_48), [
                                            [_vModelText, _unref(registerForm).company]
                                        ]),
                                        _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(t)('Firma')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "title",
                                            placeholder: _unref(t)('Anrede'),
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(registerForm).title) = $event))
                                        }, null, 8, _hoisted_51), [
                                            [_vModelText, _unref(registerForm).title]
                                        ]),
                                        _createElementVNode("label", _hoisted_52, _toDisplayString(_unref(t)('Anrede')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_53, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "firstname",
                                            placeholder: _unref(t)('Vorname'),
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(registerForm).firstname) = $event)),
                                            required: ""
                                        }, null, 8, _hoisted_54), [
                                            [_vModelText, _unref(registerForm).firstname]
                                        ]),
                                        _createElementVNode("label", _hoisted_55, _toDisplayString(_unref(t)('Vorname')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "lastname",
                                            placeholder: _unref(t)('Nachname'),
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(registerForm).lastname) = $event)),
                                            required: ""
                                        }, null, 8, _hoisted_57), [
                                            [_vModelText, _unref(registerForm).lastname]
                                        ]),
                                        _createElementVNode("label", _hoisted_58, _toDisplayString(_unref(t)('Nachname')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_59, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "email",
                                            class: "form-control",
                                            id: "email",
                                            placeholder: _unref(t)('E-Mail'),
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_unref(registerForm).email) = $event)),
                                            required: ""
                                        }, null, 8, _hoisted_60), [
                                            [_vModelText, _unref(registerForm).email]
                                        ]),
                                        _createElementVNode("label", _hoisted_61, _toDisplayString(_unref(t)('E-Mail')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_62, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "phone",
                                            placeholder: _unref(t)('Telefon'),
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_unref(registerForm).phone) = $event)),
                                            required: ""
                                        }, null, 8, _hoisted_63), [
                                            [_vModelText, _unref(registerForm).phone]
                                        ]),
                                        _createElementVNode("label", _hoisted_64, _toDisplayString(_unref(t)('Telefon')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_65, [
                                        _withDirectives(_createElementVNode("select", {
                                            class: "form-select",
                                            id: "language",
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_unref(registerForm).lang) = $event)),
                                            required: ""
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.languages, (lang, index) => {
                                                return (_openBlock(), _createElementBlock("option", { value: index }, _toDisplayString(lang), 9, _hoisted_66));
                                            }), 256))
                                        ], 512), [
                                            [_vModelSelect, _unref(registerForm).lang]
                                        ]),
                                        _createElementVNode("label", _hoisted_67, _toDisplayString(_unref(t)('Sprache')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_68, [
                                        _createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "newsletterAbo",
                                            checked: _unref(registerForm).newsletterAbo
                                        }, null, 8, _hoisted_69),
                                        _createElementVNode("label", _hoisted_70, _toDisplayString(_unref(t)('Newsletter abonnieren?')), 1)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_71, [
                                    _createElementVNode("h4", _hoisted_72, _toDisplayString(_unref(t)('Adresse')), 1),
                                    _createElementVNode("div", _hoisted_73, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "addressCompany",
                                            placeholder: _unref(t)('Firma'),
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(registerForm).addressCompany) = $event)),
                                            required: ""
                                        }, null, 8, _hoisted_74), [
                                            [_vModelText, _unref(registerForm).addressCompany]
                                        ]),
                                        _createElementVNode("label", _hoisted_75, _toDisplayString(_unref(t)('Firma')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_76, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "addressFirstname",
                                            placeholder: _unref(t)('Vorname'),
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_unref(registerForm).addressFirstname) = $event)),
                                            required: ""
                                        }, null, 8, _hoisted_77), [
                                            [_vModelText, _unref(registerForm).addressFirstname]
                                        ]),
                                        _createElementVNode("label", _hoisted_78, _toDisplayString(_unref(t)('Vorname')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_79, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "addressLastname",
                                            placeholder: _unref(t)('Nachname'),
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_unref(registerForm).addressLastname) = $event)),
                                            required: ""
                                        }, null, 8, _hoisted_80), [
                                            [_vModelText, _unref(registerForm).addressLastname]
                                        ]),
                                        _createElementVNode("label", _hoisted_81, _toDisplayString(_unref(t)('Nachname')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_82, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "address",
                                            placeholder: _unref(t)('Adresse'),
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_unref(registerForm).address) = $event)),
                                            required: ""
                                        }, null, 8, _hoisted_83), [
                                            [_vModelText, _unref(registerForm).address]
                                        ]),
                                        _createElementVNode("label", _hoisted_84, _toDisplayString(_unref(t)('Adresse')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_85, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "zipcode",
                                            placeholder: _unref(t)('PLZ'),
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_unref(registerForm).zipcode) = $event)),
                                            required: ""
                                        }, null, 8, _hoisted_86), [
                                            [_vModelText, _unref(registerForm).zipcode]
                                        ]),
                                        _createElementVNode("label", _hoisted_87, _toDisplayString(_unref(t)('PLZ')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_88, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "city",
                                            placeholder: _unref(t)('Ort'),
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_unref(registerForm).city) = $event)),
                                            required: ""
                                        }, null, 8, _hoisted_89), [
                                            [_vModelText, _unref(registerForm).city]
                                        ]),
                                        _createElementVNode("label", _hoisted_90, _toDisplayString(_unref(t)('Ort')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_91, [
                                        _withDirectives(_createElementVNode("select", {
                                            class: "form-select",
                                            id: "country",
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_unref(registerForm).countryId) = $event)),
                                            required: ""
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.countries, (country) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    value: country.id
                                                }, _toDisplayString(country.name), 9, _hoisted_92));
                                            }), 256))
                                        ], 512), [
                                            [_vModelSelect, _unref(registerForm).countryId]
                                        ]),
                                        _createElementVNode("label", _hoisted_93, _toDisplayString(_unref(t)('Land')), 1)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "password",
                                    class: "form-control",
                                    id: "password",
                                    placeholder: _unref(t)('Passwort'),
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_unref(registerForm).password) = $event)),
                                    required: ""
                                }, null, 8, _hoisted_95), [
                                    [_vModelText, _unref(registerForm).password]
                                ]),
                                _createElementVNode("label", _hoisted_96, _toDisplayString(_unref(t)('Passwort')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_97, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "password",
                                    class: "form-control",
                                    id: "passwordConfirmation",
                                    placeholder: _unref(t)('Passwort bestätigen'),
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_unref(registerForm).passwordConfirmation) = $event)),
                                    required: ""
                                }, null, 8, _hoisted_98), [
                                    [_vModelText, _unref(registerForm).passwordConfirmation]
                                ]),
                                _createElementVNode("label", _hoisted_99, _toDisplayString(_unref(t)('Passwort bestätigen')), 1)
                            ]),
                            (_unref(registerForm).password !== _unref(registerForm).passwordConfirmation)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(_unref(t)('Passwörter stimmen nicht überein')), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_101, [
                                _cache[31] || (_cache[31] = _createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "1",
                                    id: "createOrderRequestTermsConfirmation",
                                    required: ""
                                }, null, -1)),
                                _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: "createOrderRequestTermsConfirmation",
                                    innerHTML: _unref(trans)('Ich habe die {tocUrlT} und die {privacyUrlT} gelesen und bin damit einverstanden.', {
                                        tocUrlT: `<a href='${tocUrl.value}'>${_unref(t)('AGBs')}</a>`,
                                        privacyUrlT: `<a href='${privacyUrl.value}'>${_unref(t)('Datenschutzerklärung')}</a>`
                                    })
                                }, null, 8, _hoisted_102)
                            ]),
                            _createElementVNode("button", {
                                class: "w-100 btn btn-primary d-flex align-items-center justify-content-center text-white",
                                disabled: _unref(registerForm).processing || _unref(registerForm).password !== _unref(registerForm).passwordConfirmation || emailExists.value
                            }, [
                                _createTextVNode(_toDisplayString(_unref(t)('Registrieren')), 1),
                                _cache[32] || (_cache[32] = _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "ms-2 bi bi-arrow-right",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                    })
                                ], -1))
                            ], 8, _hoisted_103)
                        ], 32)
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
